import api from '../../../app/api';
import { AUTH_SCOPE } from '../constants/auth-scope';
import { AuthCredentials } from '../models/auth-credentials';
import { Token } from '../models/token';

export const authApi = api.injectEndpoints({
  endpoints: builder => ({
    getToken: builder.mutation<
      Token,
      { domain: string; code: string; codeVerifier: string; clientId: string; clientSecret: string }
    >({
      query: ({ domain, code, codeVerifier, clientId, clientSecret }) => ({
        url: '/oauth/v2/token',
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          domain,
          scope: AUTH_SCOPE,
          redirect_uri: `${window.location.origin}/oauth/callback`,
          code,
          code_verifier: codeVerifier,
          client_id: clientId,
          client_secret: clientSecret,
          grant_type: 'authorization_code',
        }),
      }),
    }),
    getAuthCredentials: builder.mutation<AuthCredentials, string>({
      query: domain => ({
        url: '/api/v1/auth/credentials',
        method: 'POST',
        credentials: 'omit',
        body: {
          domain,
          scope: [AUTH_SCOPE],
        },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetAuthCredentialsMutation, useGetTokenMutation } = authApi;
